// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__9JCgv"};